import { XIcon } from "@phosphor-icons/react/dist/csr/X";
import { cn } from "@volca/ui/lib/utils";
import { missingNote } from "@/profitability/missing";

/**
 * "3 missing" under a column's total, as a button that narrows the table to
 * the rows missing that figure, and, pressed, puts them all back.
 */
export const MissingFilter = ({
  count,
  header,
  active,
  align,
  onToggle,
}: {
  count: number;
  header: string;
  active: boolean;
  align?: "start" | "end";
  onToggle: () => void;
}) => {
  const note = missingNote(count);
  if (!note) return null;
  return (
    <span className={cn("flex", { "justify-end": align === "end" })}>
      <button
        type="button"
        aria-pressed={active}
        aria-label={
          active ? "Show all rows" : `Show the ${count} missing ${header}`
        }
        title={
          active ? "Show all rows" : `Show only the rows missing ${header}`
        }
        onClick={onToggle}
        className={cn(
          "inline-flex items-center gap-1 rounded-sm text-xs font-normal whitespace-nowrap text-subtle underline-offset-2 hover:text-ink hover:underline focus-visible:outline-2 focus-visible:outline-focus",
          { "font-medium text-ink": active },
        )}
      >
        {note}
        {active && <XIcon aria-hidden className="size-3" />}
      </button>
    </span>
  );
};
